const FULL = '.full.webp';
const THUMB = '.thumb.webp';

// Maps a canonical product photo URL (`.../<name>.full.webp`) to its
// 640px thumbnail variant. URLs that don't match the convention are
// returned unchanged — covers persisted cart snapshots from older builds.
export function thumbPhoto(url: string): string {
  return url.endsWith(FULL) ? url.slice(0, -FULL.length) + THUMB : url;
}
